import { mixed, object, string } from "yup";

import type { I18nT } from "@lib/dashboardI18n";
import "@lib/messageComposition/chatMessaging/yupHelper";
import type { SHARED_CONSTANTS_RICH_CARD_TYPES, SHARED_CONSTANTS_RICH_CARD_HEIGHTS } from "@lib/shared_constants";
import sharedConstants from "@lib/shared_constants";

import { getRcsMediaFieldsSchema } from "..";
import { getRcsBaseRichCardSchema } from "./rcsBaseRichCardSchema";

export const getRcsMediaRichCardSchema = (t: I18nT<"rcs-composer">, isTwilioProvider?: boolean) =>
  getRcsBaseRichCardSchema(t, isTwilioProvider)
    .concat(
      object({
        rich_card_type: mixed<SHARED_CONSTANTS_RICH_CARD_TYPES["MEDIA"]>()
          .oneOf([sharedConstants.RCS.RICH_CARD_TYPES.MEDIA])
          .required(),
        height: mixed<SHARED_CONSTANTS_RICH_CARD_HEIGHTS[keyof SHARED_CONSTANTS_RICH_CARD_HEIGHTS]>()
          .oneOf(Object.values(sharedConstants.RCS.RICH_CARD_HEIGHTS))
          .default(sharedConstants.RCS.RICH_CARD_HEIGHTS.MEDIUM)
          .required(),
        title: string()
          .maxLengthIgnoringLiquid(
            isTwilioProvider
              ? sharedConstants.RCS.TWILIO.VALIDATIONS.MAX_CHARACTER_LIMIT_FOR_RICH_CARD_TITLE
              : sharedConstants.RCS.VALIDATIONS.MAX_CHARACTER_LIMIT_FOR_RICH_CARD_TITLE,
            t("rcs-rich-card-title-length-error", "Title exceeds the character limit")
          )
          .optional(),
        body: string()
          .maxLengthIgnoringLiquid(
            isTwilioProvider
              ? sharedConstants.RCS.TWILIO.VALIDATIONS.MAX_CHARACTER_LIMIT_FOR_RICH_CARD_DESCRIPTION
              : sharedConstants.RCS.VALIDATIONS.MAX_CHARACTER_LIMIT_FOR_RICH_CARD_DESCRIPTION,
            t("rcs-rich-card-description-length-error", "Description exceeds the character limit")
          )
          .optional(),
      })
    )
    .concat(getRcsMediaFieldsSchema(t))
    .noUnknown();
